import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = route.queryParamMap.get('token')
      if (!token) return false

      return this.auth.decryptToken(token).pipe(
        map((resp: any) => {
          this.auth.decryptedData = resp.token
          return true
        }),
        catchError((err: unknown) => {
          console.error(err)
          return of(false)
        })
      )
  }
  
}
